module.exports = __webpack_public_path__ + "static/media/eclipse.c1c7e3f7.svg";